// @flow

const getLocalStorage = (name : any, id : any) => {
  const localStorageObject = JSON.parse(localStorage.getItem(name));
  if (localStorageObject && localStorageObject[id]) {
    return localStorageObject[id];
  }
  return false;
};

const setLocalStorage = (name : any, id : any, value : any) => {
  let localDataExisting = localStorage.getItem(name);
  localDataExisting = localDataExisting ? JSON.parse(localDataExisting) : {};
  localDataExisting[id] = value;
  localStorage.setItem(name, JSON.stringify(localDataExisting));
};

export { setLocalStorage, getLocalStorage };
